import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  registrationContainer: {
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    width: "575px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
  },
  form: {
    display: "flex",
    background: "#fff",
    flexDirection: "column",
    "& .MuiOutlinedInput-input": {
      color: "#333",
      "&::placeholder": {
        color: "#666",
      },
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
      color: "#333",
      "&::placeholder": {
        color: "#666",
      },
    },
    "& h5": {
      padding: 0,
      marginBottom: "0.75rem",
      fontSize: "1rem",
      color: "#666",
    },
  },
  inputContainer: {
    marginTop: "1.5rem",
    width: "100%",
    padding: "0 2rem",
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& input": {
      fontSize: "14px",
    },
  },
  radioButtonIAm: {
    display: "flex",
    width: "100%",
    gap: "24px",
  },
  typeClientContainer: {
    padding: "0 32px",
    "& .MuiTypography-body1": {
      fontSize: "14px",
      color: "#666"
    },
  },
  info: {
    padding: "0.5rem 1rem",
    background: "#DDDDDD",
    display: "flex",
    alignItems: "center",
    fontSize: "20px",
    gap: 16,
    margin: 24,
    "& svg": {
      color: "orange",
    },
  },
  infoNumberTN: {
    width: 24,
    height: 24,
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '& .helpOutlineIcon': {
      margin: '0 0 0 8px',
      width: 24,
      height: 24,
    }
  },
  infoText: {
    fontSize: "12px",
    color: "#666",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#fff",
    padding: "16px 24px",
    marginTop: "1rem",
    borderTop: "1px solid #ccc",
    "& .goBack": {
      border: "2px solid #26975A",
      color: "#26975A",
      height: "32px",
      "& svg": {
        fontSize: "12px",
      },
    },
    "& .next": {
      background: "#26975A",
      color: "#FFF",
      height: "32px",
    },
    "& .Mui-disabled": {
      background: "#EEE",
      color: "#999",
    },
  },
}));

export default useStyles;
